import { trackEvent } from '@offerzen/pinata-shame'

export const trackClickedPositionsLink = (source, target) => {
  trackEvent('Company: position action', {
    action: 'clicked positions link',
    origin: 'toolbar navigation',
    source,
    target,
  })
}

export const trackApplyFilters = (source, search, members) => {
  trackEvent('Company: position action', {
    action: 'filter applied',
    source,
    search,
    members,
  })
}

export const trackClearFilters = (source, trigger) => {
  trackEvent('Company: position action', {
    action: 'cleared filters',
    source,
    trigger,
  })
}

export const trackClickedViewPositionDetails = (positionId, source) => {
  trackEvent('Company: position action', {
    action: 'clicked position',
    source,
    positionId,
  })
}

export const trackClickedStat = (positionId, stat) => {
  trackEvent('Company: position action', {
    action: 'clicked stat',
    source: 'positions dashboard',
    positionId,
    stat,
  })
}

export const trackClickedPagination = (currentPage, targetPage, totalPages, itemsPerPage) => {
  trackEvent('Company: position action', {
    action: 'clicked pagination',
    source: 'positions dashboard',
    currentPage,
    targetPage,
    totalPages,
    itemsPerPage,
  })
}

export const trackClickedClosePosition = (positionId, origin) => {
  trackEvent('Company: position action', {
    action: 'clicked close',
    source: 'positions dashboard',
    origin,
    positionId,
  })
}

export const trackToggleOpenClosePositionInDetails = (positionId, action, origin) => {
  trackEvent('Company: position action', {
    action,
    origin,
    positionId,
    source: 'positions details',
  })
}

export const trackClickedReopenPosition = positionId => {
  trackEvent('Company: position action', {
    action: 'clicked reopen',
    source: 'closed positions',
    origin: 'table row',
    positionId,
  })
}

export const trackOpenedClosedPositionInDetails = ({ positionId, action, ...rest }) => {
  trackEvent('Company: position action', {
    action: `${action} position`,
    source: 'positions details',
    positionId,
    ...rest,
  })
}

export const trackViewOpenPositions = (companyState, memberRole) => {
  trackEvent('Company: position action', {
    action: 'viewed positions list',
    source: 'positions dashboard',
    companyState,
    memberRole,
  })
}

export const trackViewClosedPositions = (companyState, memberRole) => {
  trackEvent('Company: position action', {
    action: 'viewed positions list',
    source: 'closed positions',
    companyState,
    memberRole,
  })
}

export const trackToggledTooltipInDetails = () => {
  trackEvent('Company: position action', {
    action: 'toggled tooltip',
    source: 'positions details',
    origin: 'disabled form submit',
    topic: 'closed position',
  })
}

export const trackActionsMenuToggle = open => {
  trackEvent('Company: position action', {
    action: 'toggled options menu',
    source: 'positions dashboard',
    open,
  })
}

export const trackClosingReason = (positionId, closingReason, otherReason) => {
  trackEvent('Company: position action', {
    action: 'closed position',
    source: 'positions dashboard',
    positionId,
    closingReason,
    otherReason,
  })
}

export const trackViewIRsWithoutPosition = irCount => {
  trackEvent('Company: position action', {
    action: 'clicked interview requests link',
    source: 'positions dashboard',
    irsWithoutPosition: irCount,
    origin: 'irs without position notification',
  })
}

export const trackClickedUpdateJobOpenings = positionId => {
  trackEvent('Company: position action', {
    action: 'clicked update vacancies',
    source: 'positions dashboard',
    positionId,
  })
}

export const trackClickedDuplicatePosition = (positionId, origin) => {
  trackEvent('Company: position action', {
    action: 'clicked duplicate',
    source: 'positions dashboard',
    origin,
    positionId,
  })
}
